import React from 'react'
import { Box } from '@mui/material'
import { XSpecProperties } from '../../../types/carbon/models/XSpecProperties'
import { SettingsSwitch, SettingsRow } from './SettingsControls'

interface SpecPropertiesSectionProps {
  specProperties: XSpecProperties
  onChange: (specProperties: XSpecProperties) => void
}

const SpecPropertiesSection: React.FC<SpecPropertiesSectionProps> = ({ specProperties, onChange }) => {
  const update = (patch: Partial<XSpecProperties>) => onChange({ ...specProperties, ...patch })

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <SettingsRow>
        <SettingsSwitch label="Init as Missing" checked={specProperties.initAsMissing} onChange={v => update({ initAsMissing: v })} />
        <SettingsSwitch label="Exclude NE" checked={specProperties.excludeNE} onChange={v => update({ excludeNE: v })} />
      </SettingsRow>
      <SettingsRow>
        <SettingsSwitch label="Pad Hierarchics" checked={specProperties.padHierarchics} onChange={v => update({ padHierarchics: v })} />
        <SettingsSwitch label="Arith Over Stats" checked={specProperties.arithOverStats} onChange={v => update({ arithOverStats: v })} />
      </SettingsRow>
      <SettingsSwitch label="Full Stats" checked={specProperties.fullStats} onChange={v => update({ fullStats: v })} />
    </Box>
  )
}

export default SpecPropertiesSection
